// Figma: the first bar is the lightest, the last the darkest, and every bar in
// between shares the middle shade — purely position-based, not tied to the
// percentage value.
export const BAR_COLOR_FIRST = "var(--color-primary-100, #DDD6FE)";
export const BAR_COLOR_MIDDLE = "var(--color-primary-500, #9645FF)";
export const BAR_COLOR_LAST = "var(--color-primary-900, #31237D)";

export const getBarColor = (index, total) => {
  if (index === 0) return BAR_COLOR_FIRST;
  if (index === total - 1) return BAR_COLOR_LAST;
  return BAR_COLOR_MIDDLE;
};
